const sections = document.getElementsByClassName('m-faq-rubriek');

class FAQ {
  constructor(container) {
    this.container = container;
    this.build();
    this.addEventListeners();
  }

  build() {
    const { container } = this;

    this.rows = container.getElementsByClassName('m-faq-rubriek__button');
    this.activeRow = container.querySelector('.is-visible');
    this.activeNavItem = container.querySelector('.is-active');

    this.questions = container.getElementsByClassName('m-faq-rubriek__question');
  }

  addEventListeners() {
    const { rows } = this;
    const { questions } = this;

    [].map.call(rows, row => row.addEventListener('click', this.handleRowClick.bind(this)));
    
    [].map.call(questions, question => question.addEventListener('click', this.handleQuestionClick.bind(this)));
  }

  handleRowClick(event) {
    event.preventDefault();
    const { currentTarget } = event;
    const { activeRow, activeNavItem, container } = this;

    var activeQuestionItem = container.querySelector('.is-open');
    if (activeQuestionItem) activeQuestionItem.classList.remove('is-open');

    if (activeRow) activeRow.classList.remove('is-visible');
    if (activeNavItem) activeNavItem.classList.remove('is-active');

    this.activeRow = container.querySelector(`#${currentTarget.dataset.id}`);
    this.activeNavItem = currentTarget;

    this.activeNavItem.classList.add('is-active');
    this.activeRow.classList.add('is-visible');
  }

  handleQuestionClick(event) {
    event.preventDefault();
    const { currentTarget } = event;
    const { container } = this;

    if(currentTarget.parentElement.classList.contains('is-open')) {
        currentTarget.parentElement.classList.remove('is-open');
    } else {
        
        // Only 1 question open at a time : 

        //var activeQuestionItem = container.querySelector('.is-open');
        //if (activeQuestionItem) activeQuestionItem.classList.remove('is-open');

        currentTarget.parentElement.classList.add('is-open');
    }

  }
}

function initTabContent() {
  [].map.call(sections, section => new FAQ(section));
}

if (sections) initTabContent();
